module.exports = __webpack_public_path__ + "img/icon_loanout.f5cc4793.svg";